import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import markup from "ulysses/features/sla/policy_editor.html";

"use strict";
uly.actions.editslareminders = function(ev, $elt, ui) {
    var cell = ui.model;
    uly.dialogs.execute(markup,  {
        "title":_("edit_reminders_dialog_title", "Edit Reminders")
    }, cell).then(function([data]) {
        console.log("Reminders:", data);
        cell.reminders(ko.unwrap(data.reminders));
    })
};

ko.bindingHandlers.policyeditor = {
    "init": function(elt, va, allbindings, model, context) {
        var editor = {
            addReminder: function() {
                var cell = ko.unwrap(va());

                cell.reminders.push({
                    "template_id": ko.observable(null),
                    "template": {"name": ko.observable(null), "key_code": ko.observable(null)},
                    "offset": ko.observable(0),
                    "to_assignee": ko.observable(true),
                    "to_owner": ko.observable(false),
                    "to_group": ko.observable(false),
                    "to_manager": ko.observable(false)
                });
            },
            deleteReminder: function(reminder, ev) {
                console.log("delete Reminder:", arguments);
                var cell = ko.unwrap(va());
                cell.reminders.remove(function(r) { return r == reminder; });
            }
        };
        var new_context = context.extend(editor);
        ko.applyBindingsToDescendants(new_context, elt);
        return { "controlsDescendantBindings": true};
    }
};
